export const aboutData = {
  brandIntro: {
    title: '关于91网',
    subtitle: '您值得信赖的综合服务平台',
    paragraphs: [
      '91网成立于2015年，是国内领先的综合服务平台之一。我们致力于为用户提供丰富的在线资源和便捷的数字体验，涵盖软件工具、学习教程、影视娱乐、游戏攻略、资源下载、技术资讯等多个领域。',
      '经过多年的发展，91网已积累了超过500万注册用户，日均访问量突破100万次。我们的内容团队由资深编辑、行业专家和技术爱好者组成，确保每篇内容都经过严格审核，为用户提供高质量、有价值的信息。',
      '91网始终坚持"用户至上、内容为王"的核心理念，不断优化产品体验，拓展内容边界。无论是寻找实用软件、学习编程技能、发现优质影视内容，还是获取最新科技资讯，91网都是您最可靠的伙伴。',
    ],
  },
  milestones: [
    { year: '2015', title: '平台创立', description: '91网正式上线，以软件资源分享起步，迅速积累首批忠实用户。' },
    { year: '2016', title: '内容拓展', description: '新增学习教程和技术资讯频道，内容体系初步建立，注册用户突破10万。' },
    { year: '2017', title: '社区建设', description: '上线用户社区功能，开放评论和投稿系统，形成活跃的用户互动生态。' },
    { year: '2018', title: '移动优化', description: '完成全站移动端适配，推出PWA版本，移动端用户占比超过60%。' },
    { year: '2019', title: '百万用户', description: '注册用户突破100万，日均访问量超过30万次，成为行业知名平台。' },
    { year: '2020', title: '内容升级', description: '引入专家作者体系，与50+行业KOL建立合作，内容质量大幅提升。' },
    { year: '2021', title: '技术革新', description: '全面升级技术架构，页面加载速度提升300%，用户体验显著优化。' },
    { year: '2022', title: '生态扩展', description: '新增游戏攻略、影视娱乐等频道，内容覆盖范围进一步扩大。' },
    { year: '2023', title: 'AI赋能', description: '引入AI辅助内容审核和个性化推荐系统，用户满意度提升至95%。' },
    { year: '2024', title: '全新出发', description: '用户突破500万，全新品牌升级，持续为中文互联网用户提供优质服务。' },
  ],
  values: [
    { icon: 'ri-shield-check-line', title: '值得信赖', description: '严格的内容审核机制，确保信息准确可靠，用户数据安全有保障。' },
    { icon: 'ri-lightbulb-flash-line', title: '持续创新', description: '不断探索新技术、新形式，为用户带来更好的内容消费体验。' },
    { icon: 'ri-team-line', title: '用户至上', description: '以用户需求为导向，持续优化产品功能和服务质量。' },
    { icon: 'ri-leaf-line', title: '内容为王', description: '坚持原创优质内容，拒绝低质搬运，打造有价值的信息平台。' },
  ],
  contactInfo: {
    email: 'support@91wang.com',
    wechat: '91wang_official',
    qq: '800123456',
    workHours: '周一至周五 9:00 - 18:00',
    address: '中国北京市海淀区中关村科技园区',
  },
};